export enum BatchTray {
  None = 0,
  Top = 1,
  Middle = 2,
  Bottom = 3,
}

export enum Shelf {
  Top = 1,
  Second = 2,
  Third = 3,
  Fourth = 4,
  Fifth = 5,
}
